import React, { useContext, useEffect, useState } from 'react';
import format from 'date-fns/format';

import useApi from 'common/useApi';
import UiContext from 'common/UiContext/UiContext';

import displayHashrateValue from 'common/displayHashrateValue';

import RewardsSummary from 'components/RewardsSummary';
import DataTable from 'components/DataTable';

import formatBtc from 'common/formatBtc';
import DataTablePagination from 'components/DataTablePagination';
import classNames from 'classnames';

const Rewards = () => {
  const { addToast } = useContext(UiContext);
  const [page, setPage] = useState(1);

  const { data, isError, isLoading } = useApi('get', '/api/dashboard/totals');
  const {
    data: rewards,
    isError: isErrorRewards,
    isLoading: isLoadingRewards,
    isFetching,
  } = useApi('getList', '/api/rewards', { page });

  const headers = [
    'Block found at',
    'Pool Scoring Hashrate',
    'Your Scoring Hashrate',
    'Your Reward',
    'Block Height',
    'Status',
  ];

  const rewardList = () => rewards?.results.map(({
    date,
    pool_scoring_hashrate,
    your_scoring_hashrate,
    block,
    your_reward,
    status,
  }: {
    date: string
    pool_scoring_hashrate: string
    your_scoring_hashrate: string
    block: number
    your_reward: string
    status: string
  }) => [
    format(new Date(date), 'yyyy-MM-dd HH:mm:ss'),
    `${Object.values(displayHashrateValue(parseFloat(pool_scoring_hashrate))).join(' ')}h/s`,
    `${Object.values(displayHashrateValue(parseFloat(your_scoring_hashrate))).join(' ')}h/s`,
    formatBtc(your_reward),
    block,
    {
      entry: status,
      formatter: 'StatusBadge',
    },
  ]);


  useEffect(() => {
    if(isError || isErrorRewards){
        addToast!('Error loading data. Please, retry');
    }
  }, [isError, isErrorRewards]);

  if(!data || !rewards) {
    return null;
  }

  return (
    <>
      <RewardsSummary isLoading={isLoading} boxed={true} data={data} />
      <div
        className={classNames({
          box: true,
          isLoading: isLoadingRewards || isFetching,
          table: true,
        })}
      >
        <DataTable isLoading={isLoadingRewards || isFetching} headers={headers} content={rewardList() ?? []} />
        <DataTablePagination
          page={page}
          totalItems={rewards?.count ?? 0}
          setPage={setPage}
        />
      </div>
    </>
  );
};

export default Rewards;
